import { Injectable, Input, EventEmitter } from '@angular/core';
import { BaseService } from './BaseService';
import { APIServiceConnector } from './APIServiceConnector';
import * as enumModels from '../Models/EnumModels';
import { MasterDataRequest, ComplainRegister, ComplainSearch, ComplainGSRAnswers, ComplainEnableKMT, WOSearch, InventoryItemsPayload } from '../Models/RequestModels';
import { AppSettings } from '../Library/AppSettings';
import { SimpleResponse, ListResponse } from '../Models/ResponseModels';
import { MasterDataService } from './MasterDataService';
import * as moment from 'moment';
const momentDuration = require("moment-duration-format");
/*import * as momentDuration from "moment-duration-format";*/
import 'moment-duration-format';
import { ComplainSearch_GroupBy, JobOperationActions } from '../Models/EnumModels';
import * as alasql from 'alasql';
import { ComplainSignalRService } from './ComplainSignalRService';
import { GSRAudit } from '../Components/GSRAudit/GSRAudit';
import { Priorities, WorkOrderStatuses } from '../Models/EnumModels';

//declare module 'moment' {
//    interface Duration {
//        format(template: string, precision?: string, settings?: DurationFormatSettings): string;
//    }

//    //interface DurationFormatSettings {
//    //    template: string;
//    //    precision: number;
//    //    trim: boolean;
//    //    forceLength: boolean;
//    //}
//}


@Injectable()
export class ComplainService extends BaseService {
    public _SelectedJob: any = null;
    public increasePopupOpacity : boolean = false;

    public JobConsoleRefreshEvent: EventEmitter<number> = new EventEmitter<number>();
    public ComplainRowChanged: EventEmitter<any> = new EventEmitter<any>();
    public ComplainStatsChanged: EventEmitter<any> = new EventEmitter<any>();
    public ComplainRowAdded: EventEmitter<any> = new EventEmitter<any>();
    public RefreshComplete: EventEmitter<any> = new EventEmitter<any>();

    Cache_UpdatedComplains: Array<any> = [];
    propertySettingsData = {}
    URL_WorkOrders: string;
    URL_KMTConfig : string;
    InvBaseURL: string;
    constructor(public apiService: APIServiceConnector, public masterService: MasterDataService, public complainSignalRService: ComplainSignalRService) {
        super();
        this.BaseURL = AppSettings.URL_ComplainService;
        this.InvBaseURL = AppSettings.URL_Inventory;
        this.URL_WorkOrders = AppSettings.URL_WorkOrders;
        this.URL_KMTConfig = AppSettings.URL_KMTConfig;
        momentDuration(moment);

        complainSignalRService.Complain_Updated.subscribe(data => this.onComplain_Updated(data));
        complainSignalRService.Complain_Added.subscribe(data => this.onComplain_Added(data));

    }

    public set SelectedJob(value: any) {
        this._SelectedJob = value;
    }

    public get SelectedJob() :any {
        return this._SelectedJob;
    }

    getWorkOrderStatuses(
        showCancelled = false
      ) {
        return [
          {
            Name: 'LBL.UNASSIGNED',
            Id: WorkOrderStatuses.Created,
          },
          {
            Name: 'LBL.ASSIGNED',
            Id: WorkOrderStatuses.Assigned,
          },
          {
            Name: 'LBL.LBL_PENDING_APPROVE',
            Id: WorkOrderStatuses.PendingApproval,
          },
          {
            Name: 'LBL.IN_PROGRESS',
            Id: WorkOrderStatuses.Started,
          },
          {
            Name: 'LBL.LBL_PARKED',
            Id: WorkOrderStatuses.Parked,
          },
          // {
          //   Name: 'Pending Inspection',
          //   Id: WorkOrderStatuses.AwaitingAudit,
          // },
          {
            Name: 'LBL.LBL_COMPLETED',
            Id: WorkOrderStatuses.Closed,
          },
          ...(showCancelled
            ? [
                {
                  Name: 'LBL.LBL_CANCELLED',
                  Id: WorkOrderStatuses.Cancelled,
                },
              ]
            : []),
        ];
      }

    Cache_ClearComplainUpdated(): void {
        this.Cache_UpdatedComplains = [];
        this.RefreshComplete.emit(1);
    }

    HandleComplainUpdate(OLTPData: any): void {
        if (OLTPData == null)
            return;

        OLTPData.IsRecentlyUpdated = 2;

        let resp = new ListResponse();
        resp.Result = [OLTPData];
        this.Complain_Search_Multi(resp);

        let idx = this.Cache_UpdatedComplains.findIndex(a => a.ComplainId == OLTPData.ComplainId);
        if (idx >= 0) {
            this.Cache_UpdatedComplains[idx] = OLTPData;
        }
        else {
            this.Cache_UpdatedComplains.push(OLTPData);
        }

        this.ComplainRowChanged.emit(OLTPData);
    }

    onComplain_Updated(data: any): void {
        if (data == null || data.OLTPData == null)
            return;

        this.HandleComplainUpdate(data.OLTPData);
        this.HandleComplainUpdate(data.Prev_AssignedTo_ComplainOLTP);

        this.ComplainStatsChanged.emit(data);
    }

    onComplain_Added(data: any): void {
        if (data == null)
            return;

        data.IsRecentlyUpdated = 1;

        let resp = new ListResponse();
        resp.Result = [data];
        this.Complain_Search_Multi(resp);

        this.ComplainRowAdded.emit(data);

        this.Cache_UpdatedComplains.push(data);
    }

    RegisterCall(req: Array<ComplainRegister>): Promise<SimpleResponse> {
        if (req == null || req.length == 0)
            return null;

        return this.apiService.postAPI(this.BaseURL, "Complain/RegisterCall", req).then(data => {
            this.Complain_Search_Multi(data);
            return data;
        });
    }

    Complain_Update(req: ComplainRegister): Promise<SimpleResponse> {
        if (req == null)
            return null;

        return this.apiService.postAPI(this.BaseURL, "Complain/Complain_Update", req, true).then(data => {
            if (data.HasError)
                return data;

            let res: ListResponse;
            res = new ListResponse();
            res.Result = [data.Result.OLTPData];
            this.Complain_Search_Multi(res);

            if (req.Operation != JobOperationActions.ChangeAttachments) {
                this.JobConsole_ToUpdate(req.ComplainId);
            }
            else {
                if (data != null && data.Result != null)
                    this.ComplainRowChanged.emit(data.Result);
            }

            return data;
        });
    }

    Complain_Search_Multi(req: ListResponse): void {
        if (req == null)
            return;

        if (req.Result == null)
            return;

        if(req.Result.length){
            for (let i = 0; i < req.Result.length; i++) {
                let row = req.Result[i];

                let propId = row.PropertyId;

                row.TimeLeftText = null;
                row.MRTDuration = null;
                row.MRTText = null;
                row.EstimatedTimeToAttendText = null;

                row.RegisteredAt = new Date(row.RegisteredAt);
                row.LastUpdate = new Date(row.LastUpdate);
                if (row.CalculatedFinishDate)
                    row.CalculatedFinishDate = new Date(row.CalculatedFinishDate);
                if (row.LastActionTime)
                    row.LastActionTime = new Date(row.LastActionTime);
                if (row.ClosedAt)
                    row.ClosedAt = new Date(row.ClosedAt);
                if (row.NextEscTime)
                    row.NextEscTime = new Date(row.NextEscTime);
                if (row.FirstEscalationTime)
                    row.FirstEscalationTime = new Date(row.FirstEscalationTime);
                if (row.ParkReopenTime)
                    row.ParkReopenTime = new Date(row.ParkReopenTime);

                if (row.RegisteredAt != null && row.MRT != null) {
                    let sDate = moment(row.RegisteredAt);
                    sDate = sDate.add('minutes', row.MRT);
                    row.MRTDuration = moment.duration(row.MRT, 'minutes');
                    row.MRTText = row.MRTDuration.format('dd:hh:mm', {
                        trim: false
                    });
                }

                if (row.EstimatedTimeToAttend != null) {
                    if (row.EstimatedTimeToAttend <= 0) {
                        row.EstimatedTimeToAttendText = "LBL.IMMEDIATELY";
                    }
                    else {
                        row.EstimatedTimeToAttendText = moment.duration(row.EstimatedTimeToAttend, 'minutes').format('dd:hh:mm', {trim:false});
                    }
                }

                row.IsControlWithKSV = !row.IsKMTCategory;

                row.SectionName = this.masterService.MasterData_GetMutli(propId, row.SectionId, enumModels.EntityCodes.Sections, row.SectionName);
                row.DepartmentName = this.masterService.MasterData_GetMutli(propId, row.DeptId, enumModels.EntityCodes.Dept, row.DepartmentName);

                row.StatusDescription = this.masterService.MasterData_GetMutli(propId, row.CurrentStatus, enumModels.EntityCodes.ComplainSatuses, row.StatusDescription);
                //row.VIPCODE = this.masterService.MasterData_GetMutli(row.LocationId, enumModels.EntityCodes.Location, row.VIPCODE);

                row.AssignToName = this.masterService.MasterData_GetMutli(propId, row.AssignedTo, enumModels.EntityCodes.Staff, row.AssignToName);
                row.CallDescription = this.masterService.MasterData_GetMutli(propId, row.CallDescriptionsId, enumModels.EntityCodes.CallDescriptions, row.CallDescription);
                row.LocationName = this.masterService.MasterData_GetMutli(propId, row.LocationId, enumModels.EntityCodes.Location, row.LocationName);
                //row.LocationTypeDescription = this.masterService.MasterData_GetMutli(row.LocationId, enumModels.EntityCodes.Location, row.LocationTypeDescription);
                row.RequestedByStaffName = this.masterService.MasterData_GetMutli(propId, row.RequestedByStaffId, enumModels.EntityCodes.Staff, row.RequestedByStaffName);
                row.LoggedByName = this.masterService.MasterData_GetMutli(propId, row.LoggedBy, enumModels.EntityCodes.Staff, row.LoggedByName);
                //row.REPORTERNAME = this.masterService.MasterData_GetMutli(propId, row.REPORTERID, enumModels.EntityCodes.Staff, row.REPORTERNAME);
                row.ClosedByStaffName = this.masterService.MasterData_GetMutli(propId, row.LastClosedByStaffCode, enumModels.EntityCodes.Staff, row.ClosedByStaffName);

                row.PriorityDescription = this.masterService.StaticData_GetMutli(row.Priotity, enumModels.EntityCodes.Priority, row.PriorityDescription);

                if (row.IsRecentlyUpdated == undefined || row.IsRecentlyUpdated == null)
                    row.IsRecentlyUpdated = null;

                //let cache_Update_Index = this.Cache_UpdatedComplains.findIndex(a => { return a.ComplainId == row.ComplainId } );
                //if (cache_Update_Index >= 0)
                //    row.IsRecentlyUpdated = true;
            }
        }else {

            let row = req.Result;

            let propId = row.PropertyId;

            row.TimeLeftText = null;
            row.MRTDuration = null;
            row.MRTText = null;
            row.EstimatedTimeToAttendText = null;

            row.RegisteredAt = new Date(row.RegisteredAt);
            row.LastUpdate = new Date(row.LastUpdate);
            if (row.CalculatedFinishDate)
                row.CalculatedFinishDate = new Date(row.CalculatedFinishDate);
            if (row.LastActionTime)
                row.LastActionTime = new Date(row.LastActionTime);
            if (row.ClosedAt)
                row.ClosedAt = new Date(row.ClosedAt);
            if (row.NextEscTime)
                row.NextEscTime = new Date(row.NextEscTime);
            if (row.FirstEscalationTime)
                row.FirstEscalationTime = new Date(row.FirstEscalationTime);
            if (row.ParkReopenTime)
                row.ParkReopenTime = new Date(row.ParkReopenTime);

            if (row.RegisteredAt != null && row.MRT != null) {
                let sDate = moment(row.RegisteredAt);
                sDate = sDate.add('minutes', row.MRT);
                row.MRTDuration = moment.duration(row.MRT, 'minutes');
                row.MRTText = row.MRTDuration.format('dd:hh:mm', {
                    trim: false
                });
            }

            if (row.EstimatedTimeToAttend != null) {
                if (row.EstimatedTimeToAttend <= 0) {
                    row.EstimatedTimeToAttendText = "LBL.IMMEDIATELY";
                }
                else {
                    row.EstimatedTimeToAttendText = moment.duration(row.EstimatedTimeToAttend, 'minutes').format('dd:hh:mm', {trim:false});
                }
            }

            row.IsControlWithKSV = !row.IsKMTCategory;

            row.SectionName = this.masterService.MasterData_GetMutli(propId, row.SectionId, enumModels.EntityCodes.Sections, row.SectionName);
            row.DepartmentName = this.masterService.MasterData_GetMutli(propId, row.DeptId, enumModels.EntityCodes.Dept, row.DepartmentName);

            row.StatusDescription = this.masterService.MasterData_GetMutli(propId, row.CurrentStatus, enumModels.EntityCodes.ComplainSatuses, row.StatusDescription);
            //row.VIPCODE = this.masterService.MasterData_GetMutli(row.LocationId, enumModels.EntityCodes.Location, row.VIPCODE);

            row.AssignToName = this.masterService.MasterData_GetMutli(propId, row.AssignedTo, enumModels.EntityCodes.Staff, row.AssignToName);
            row.CallDescription = this.masterService.MasterData_GetMutli(propId, row.CallDescriptionsId, enumModels.EntityCodes.CallDescriptions, row.CallDescription);
            row.LocationName = this.masterService.MasterData_GetMutli(propId, row.LocationId, enumModels.EntityCodes.Location, row.LocationName);
            //row.LocationTypeDescription = this.masterService.MasterData_GetMutli(row.LocationId, enumModels.EntityCodes.Location, row.LocationTypeDescription);
            row.RequestedByStaffName = this.masterService.MasterData_GetMutli(propId, row.RequestedByStaffId, enumModels.EntityCodes.Staff, row.RequestedByStaffName);
            row.LoggedByName = this.masterService.MasterData_GetMutli(propId, row.LoggedBy, enumModels.EntityCodes.Staff, row.LoggedByName);
            //row.REPORTERNAME = this.masterService.MasterData_GetMutli(propId, row.REPORTERID, enumModels.EntityCodes.Staff, row.REPORTERNAME);
            row.ClosedByStaffName = this.masterService.MasterData_GetMutli(propId, row.LastClosedByStaffCode, enumModels.EntityCodes.Staff, row.ClosedByStaffName);

            row.PriorityDescription = this.masterService.StaticData_GetMutli(row.Priotity, enumModels.EntityCodes.Priority, row.PriorityDescription);

            if (row.IsRecentlyUpdated == undefined || row.IsRecentlyUpdated == null)
                row.IsRecentlyUpdated = null;

            //let cache_Update_Index = this.Cache_UpdatedComplains.findIndex(a => { return a.ComplainId == row.ComplainId } );
            //if (cache_Update_Index >= 0)
            //    row.IsRecentlyUpdated = true;
        }




        //console.info(req);
    }

    Complain_Search_Groups_Multi(req: ListResponse, Request: ComplainSearch): void {
        if (req == null)
            return;

        if (req.Result == null)
            return;

        let lst = new Array<any>();

        for (let i = 0; i < Request.Properties.length; i++) {
            let propID = Request.Properties[i];

            let objProp = this.masterService.Cache_PropertyMainMasters.getValue(propID);

            if (objProp != null) {
                let res: Array<any>;

                switch (Request.GroupBy) {
                    case ComplainSearch_GroupBy.AssignedTo:
                        lst = lst.concat(alasql("Select * from ? where Id not in (Select Id from ?)", [objProp.Staff, lst]));
                        break;
                    case ComplainSearch_GroupBy.CallCategories:
                        lst = lst.concat(alasql("Select * from ? where Id not in (Select Id from ?)", [objProp.CallCategories, lst]));
                        break;
                    case ComplainSearch_GroupBy.CallDescriptions:
                        lst = lst.concat(alasql("Select * from ? where Id not in (Select Id from ?)", [objProp.CallDescriptions, lst]));
                        break;
                    case ComplainSearch_GroupBy.Dept:
                        lst = lst.concat(alasql("Select * from ? where Id not in (Select Id from ?)", [objProp.Dept, lst]));
                        break;
                    case ComplainSearch_GroupBy.Location:
                        lst = lst.concat(objProp.Location);
                        break;
                    case ComplainSearch_GroupBy.Sections:
                        lst = lst.concat(alasql("Select * from ? where Id not in (Select Id from ?)", [objProp.Sections, lst]));
                        break;
                }
            }

        }

        for (let i = 0; i < req.Result.length; i++) {
            let row = req.Result[i];

            let str: string = "";

            switch (Request.GroupBy) {
                case ComplainSearch_GroupBy.AssignedTo:
                case ComplainSearch_GroupBy.Dept:
                case ComplainSearch_GroupBy.Sections:
                    str = alasql("Select Value Name from ? where Id = ?", [lst, row.Id]);
                    break;
                case ComplainSearch_GroupBy.CallCategories:
                case ComplainSearch_GroupBy.CallDescriptions:
                case ComplainSearch_GroupBy.Location:
                    str = alasql("Select Value Description from ? where Id = ?", [lst, row.Id]);
                    break;
                case ComplainSearch_GroupBy.Property:
                    let prop = this.masterService.GetProperty(row.Id);
                    if (prop != null)
                        str = prop.PropertyName;
                    break;
                case ComplainSearch_GroupBy.Priority:
                    if (row.Id == Priorities.Crisis) {
                        str = 'Crisis';
                    }
                    if (row.Id == Priorities.Normal) {
                        str = 'Normal';
                    }
                    if (row.Id == Priorities.Urgent) {
                        str = 'Urgent';
                    }
                    if (row.Id == Priorities.XtraUrgent) {
                        str = 'XtraUrgent';
                    }
            }

            row.GroupName = str;
        }
    }

    Complain_Search(req: ComplainSearch): Promise<ListResponse> {
        return this.apiService.postAPI(this.BaseURL, "Complain/Complain_Search", req, false).then(data => {
            if (req.GroupBy == ComplainSearch_GroupBy.None) {
                this.Complain_Search_Multi(data);
            }
            else {
                this.Complain_Search_Groups_Multi(data, req);
            }

            this.Cache_ClearComplainUpdated();

            return data;
        });
    }

    WO_Search(req: WOSearch): Promise<ListResponse> {
        return this.apiService.postAPI(this.URL_WorkOrders, "WorkOrder/WorkOrder_StaffWorkOrderSearch", req, false).then(data => {
            return data;
        }).catch(()=>{
            return {}
        });
    }

    Property_Settings(propertyId: number): Promise<any> {
        if (this.propertySettingsData[propertyId])
        return this.propertySettingsData[propertyId];
        return this.apiService
        .getAPI(this.URL_KMTConfig, 'property-settings/' + propertyId)
        .then((response) => {
            this.propertySettingsData[propertyId] = response;
            return response;
        });
    }

    Complain_History_Multi(req: any): void {
        if (req == null)
            return;


        for (let i = 0; i < req.ComplainHistory.length; i++) {
            let row = req.ComplainHistory[i];

            let propId = row.PropertyId;
            // K50-340
            row.ActionName = this.masterService.GetComplainActionLabel(row.Action)// MasterData_GetMutli(propId, row.Action, enumModels.EntityCodes.ComplainSatuses, row.Action);
            row.StatusName = this.masterService.MasterData_GetMutli(propId, row.Status, enumModels.EntityCodes.ComplainSatuses, row.Status);

            //row.VIPCODE = this.masterService.MasterData_GetMutli(row.LocationId, enumModels.EntityCodes.Location, row.VIPCODE);

            //if (row.Action && row.Action != null && row.Action == 'TAG') {
            //    let tagStaffList = row.Remarks.split(',');
            //    let tagStaff = '';
            //    for (let i = 0; i < tagStaffList.length; i++) {
            //        tagStaff += this.masterService.MasterData_GetMutli(propId, tagStaffList[i], enumModels.EntityCodes.Staff, "") + ', ';
            //    }
            //    if (tagStaffList.length > 0)
            //        tagStaff = tagStaff.replace(/, $/, '');
            //    row.Remarks = tagStaff;
            //}

            row.AssignedStaffName = "";
            if (row.AssignedStaffId != null)
                row.AssignedStaffName = this.masterService.MasterData_GetMutli(propId, row.AssignedStaffId, enumModels.EntityCodes.Staff, row.AssignedStaffId);

            row.ReasonName = "";
            if (row.ReasonId != null)
                row.ReasonName = this.masterService.MasterData_GetMutli(propId, row.ReasonId, enumModels.EntityCodes.Reason, row.ReasonId);

            row.LoggedByName = "";
            if (row.LoggedBy != null)
                row.LoggedByName = this.masterService.MasterData_GetMutli(propId, row.LoggedBy, enumModels.EntityCodes.Staff, row.LoggedBy);
        }
    }

    Complain_GetHistory(req: number): Promise<ListResponse> {
        return this.apiService.getAPI(this.BaseURL, "Complain/Complain_GetHistory?ComplainId=" + this.URLEncode(req), false).then(data => {
            if (data != null) {
                this.Complain_History_Multi(data);
            }

            return data;
        });
    }

    GetInventoryDetails(req: InventoryItemsPayload): Promise<any> {
        return this.apiService.getAPI(this.BaseURL, "Complain/GetInventoryTransactions?ComplainId=" + req.ComplainId + "&propertyId=" + req.propertyId , false).then(data => {
            return data;
        });
    }

     GetGuestDetailsForInventory(req: InventoryItemsPayload): Promise<any> {
        return this.apiService.postAPI(this.BaseURL, "Complain/GetGuestDetailsForInventory" , req, false).then(data => {
            return data;
        });
    }

    GetInventoryItemLocations(inventoryId: any): Promise<any> {
        return this.apiService.getAPI(this.InvBaseURL, "inventory/api/part/" + inventoryId, false).then(data => {
            return data;
        });
    }

    Complain_AllPending(LocationId: number): Promise<ListResponse> {
        let req = new ComplainSearch();

        req.AllPending = true;
        req.Locations = [];
        req.Locations.push(LocationId);
        req.PageSize = 25;
        req.PageNumber = 1;
        req.OrderBy = "REPORTEDAT";

        return this.Complain_Search(req).then(data => {
            return data;
        });
    }

    Complain_StatusCounts(req: ComplainSearch): Promise<any> {
        return this.apiService.postAPI(this.BaseURL, "Complain/Complain_StatusCounts", req, false).then(data => {
            //this.Complain_Search_Multi(data);
            return data;
        });
    }

    Complain_GetGSRQuestions(PropertyId: number, LanguageCode: string): Promise<any> {
        return this.apiService.getAPI(this.BaseURL, "Complain/Complain_GetGSRQuestions?PropertyId=" + PropertyId + "&LanguageCode=" + LanguageCode, false).then(data => {
            return data;
        })
    }

    Complain_SaveGSRRating(complainGSRAnswers: ComplainGSRAnswers): Promise<any> {
        return this.apiService.postAPI(this.BaseURL, "Complain/Complain_SaveGSRRating", complainGSRAnswers, true).then(data => {
            return data;
        });
    }

    //Complain_GetAttachmentStream(CallRegAttachmentId: number): Promise<any> {
    //    return this.apiService.getAPI(this.BaseURL, "Complain/Complain_GetAttachmentStream?CallRegAttachmentId=" + this.URLEncode(CallRegAttachmentId), false).then(data => {
    //        return window. data;
    //    });
    //}

    JobConsole_ToUpdate(ComplainId: number): void {
        this.JobConsoleRefreshEvent.emit(ComplainId);
    }

    Complain_GetGSRAudit(ComplainId: number): Promise<any> {
        return this.apiService.getAPI(this.BaseURL, "Complain/Complain_GetGSRAudit?ComplainId=" + ComplainId, false).then(data => {
            return data;
        });
    }

    GetWorkOrderDetailForJob(jobId: number): Promise<any> {
        return this.apiService.getAPI(this.URL_WorkOrders, "WorkOrder/WorkOrder_Detail_For_JobId?jobId=" + jobId + "&includeLinkedWO=false&notRequiredCheckListItems=false", false).then(data => {
            return data;
        });
    }

    Complain_EnableKMT(complain: ComplainEnableKMT): Promise<any> {
        return this.apiService.postAPI(this.BaseURL, "Complain/Complain_EnableKMT", complain , true).then(data => {

            this.Complain_Search_Multi(data);
            return data;
        });
    }
}



